// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import packageInfo from 'package.json';

export const environment = {
  production: true,
  mapIrXApiKey: "sdsdsd",
  appVersion: packageInfo.version,
  mapBoxToken:"sdsdsd",
  configurationPath: 'assets/json/configurations/configuration.prod.json',
  isShowDocumentationBtn: false,
};
